import { useContext, useEffect } from 'react';
import SearchContext from 'contexts/SearchContext';
import { isEmpty } from 'lodash';

const useSearch = ({ keyword, listOfItems, fields } = { keyword: '', listOfItems: [], fields: {} }) => {
  const {
    filteredItems,
    setFilteredItems,
  } = useContext(SearchContext);

  const performFiltering = (array, word, searchFields) => {
    const searchWord = word.toLowerCase();
    const reducer = (accumulator, currentValue) => accumulator || currentValue;
    const anyFieldMatches = (item, searchableFields) => (
      searchableFields.map((f) => item[f] && item[f].toLowerCase().includes(searchWord)).reduce(reducer));
    const filteredList = array.filter(
      (i) => (searchWord === '' || (!isEmpty(searchFields) && anyFieldMatches(i, searchFields))),
    );
    return filteredList;
  };

  useEffect(() => {
    setFilteredItems(performFiltering(listOfItems, keyword, fields));
  }, [fields, keyword, listOfItems, setFilteredItems]);

  return { filteredItems };
};

export default useSearch;
